module.exports = __webpack_public_path__ + "static/media/AP_Moderate_Z1.a4384323.png";